import * as VueRouter from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'AboutApp',
        component: () => import('../views/AboutApp.vue')
    },
    {
        path: '/connexion',
        name: 'LoginPage',
        component: () => import('../views/LoginPage.vue')
    },
    {
        path: '/change-password/:token',
        name: 'ChangePassword',
        component: () => import('../views/ChangePassword.vue')
    },
    {
        path: '/send-change-password-email',
        name: 'SendChangePasswordEmail',
        component: () => import('../views/SendChangePasswordEmail.vue')
    },

    {
        path: '/groupe/:buyGroupId/produits/admin',
        name: 'AdminProducts',
        component: () => import('../views/AdminProducts.vue')
    },
    {
        path: '/groupe/:buyGroupId/produits/admin/deprecated',
        name: 'AdminProductsDeprecated',
        component: () => import('../views/AdminProducts.vue')
    },
    {
        path: '/groupe/:buyGroupId/catalogues',
        name: 'ProviderCatalogs',
        component: () => import('../views/ProviderCatalogs.vue')
    },
    {
        path: '/catalogues/items',
        name: 'CatalogItems',
        component: () => import('../views/CatalogItems.vue')
    },
    {   
        path: '/catalogues/upload',
        name: 'ProviderCatalogUpload',
        component: () => import('../views/ProviderCatalogUpload.vue')
    },
    {
        path: '/catalogues/admin',
        name: 'ProviderCatalogAdmin',
        component: () => import('../views/ProviderCatalogAdmin.vue')
    },
    {
        path: '/produits/import',
        name: 'ImportProducts',
        component: () => import('../views/ImportProducts.vue')
    },
    {
        path: '/groupe/:buyGroupId/commandes',
        name: 'GroupOrders',
        component: () => import('../views/GroupOrders')
    },
    {
        path: '/groupe/:buyGroupId/membres',
        name: 'MembersAdmin',
        component: () => import('../views/MembersAdmin')
    },
    {
        path: '/groupe/ajouter',
        name: 'GroupAdd',
        component: () => import('../views/GroupInfo')
    },
    {
        path: '/groupe/:buyGroupId',
        name: 'GroupInfo',
        component: () => import('../views/GroupInfo')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId',
        name: 'GroupOrder',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/tous-les-items',
        name: 'GroupOrderAllItems',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/diviser',
        name: 'ProductsToDivide',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/factures-membres',
        name: 'GroupOrderMemberBills',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/factures-membres/:userId',
        name: 'GroupOrderMemberBillsForMember',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/factures-membres/:userId/print',
        name: 'UserBillPrint',
        component: () => import('../views/UserBillPrint.vue')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/factures-membres/:userId/page',
        name: 'UserBillPage',
        component: () => import('../views/UserBillPage')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/commandes-fournisseurs',
        name: 'GroupOrderProvidersOrders',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/commandes-fournisseurs/:providerName',
        name: 'GroupOrderProvidersOrderForProvider',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/groupe/:buyGroupId/commande/:orderId/frais-pour-tous',
        name: 'GroupOrderFeeOnAllBills',
        component: () => import('../views/GroupOrder')
    },
    {
        path: '/:buyGroup/',
        name: 'ProductsPage',
        component: () => import('../views/ProductsPage')
    },
    {
        path: '/:buyGroup/votre-commande',
        name: 'ProductsPageYourOrder',
        component: () => import('../views/ProductsPage')
    },
    {
        path: '/:buyGroup/diviser',
        name: 'ProductsPageToDivide',
        component: () => import('../views/ProductsPage')
    },
    {
        path: '/:buyGroup/tous-les-produits',
        name: 'ProductsPageAllProducts',
        component: () => import('../views/ProductsPage')
    },
    {
        path: '/:buyGroup/inscription',
        name: 'RegisterPage',
        component: () => import('../views/RegisterPage.vue')
    },
    {
        path: '/:buyGroup/commande-membre/:memberId',
        name: 'ProductsOrderOfMember',
        component: () => import('../views/ProductsPage')
    },
    {
        path: '/groupes',
        name: 'GroupsList',
        component: () => import('../views/GroupsList')
    }
]

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    base: process.env.BASE_URL,
    routes
})

export default router
